import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '../../models/store';

@Component({
  selector: 'app-dialog-list-networks',
  templateUrl: './dialog-list-networks.component.html',
  styleUrls: ['./dialog-list-networks.component.sass']
})
export class DialogListNetworksComponent implements OnInit {
  store: Store;

  constructor(
    public dialogRef: MatDialogRef<DialogListNetworksComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.store = this.data.store;
  }

  ngOnInit() {
  }

  onClose() {
    this.dialogRef.close(true);
  }
}
